module.exports = __webpack_public_path__ + "static/media/food3.0e4f926a.jpg";